<app-title>{{titleText}}</app-title>
<app-account-dashboard-list></app-account-dashboard-list>
<div style="width:100%;height:56px;"></div>
<div id="button-container" class="mat-app-background mat-elevation-z8">
  <div>
    <mat-form-field>
      <mat-label>処理年月</mat-label>
      <mat-select [(value)]="offset">
        <mat-option *ngFor="let month of months" [value]="month.value">
          {{month.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="accent" (click)="onClickArchiveButton()">確定</button>
  </div>
</div>